// extracted by mini-css-extract-plugin
export default {"controls":"SliderControls_controls__BN24u","btn":"SliderControls_btn__1+DJV"};